export const FETCH_DEVICES_REQUEST = 'FETCH_DEVICES_REQUEST';
export const FETCH_DEVICES_SUCCESS = 'FETCH_DEVICES_SUCCESS';
export const FETCH_DEVICES_FAILURE = 'FETCH_DEVICES_FAILURE';

export const UPDATE_DEVICE_REQUEST = 'UPDATE_DEVICE_REQUEST';
export const UPDATE_DEVICE_SUCCESS = 'UPDATE_DEVICE_SUCCESS';
export const UPDATE_DEVICE_FAILURE = 'UPDATE_DEVICE_FAILURE';

export const UPDATE_PAYMENT_REQUEST = 'UPDATE_PAYMENT_REQUEST';
export const UPDATE_PAYMENT_SUCCESS = 'UPDATE_PAYMENT_SUCCESS';
export const UPDATE_PAYMENT_FAILURE = 'UPDATE_PAYMENT_FAILURE';

export const SEARCH_DEVICES_REQUEST = 'SEARCH_DEVICES_REQUEST';
export const SEARCH_DEVICES_SUCCESS = 'SEARCH_DEVICES_SUCCESS';
export const SEARCH_DEVICES_FAILURE = 'SEARCH_DEVICES_FAILURE';

export const SEARCH_PAYMENTS_REQUEST = 'SEARCH_PAYMENTS_REQUEST';
export const SEARCH_PAYMENTS_SUCCESS = 'SEARCH_PAYMENTS_SUCCESS';
export const SEARCH_PAYMENTS_FAILURE = 'SEARCH_PAYMENTS_FAILURE';

export const fetchDevicesRequest = (page, limit) => ({
  type: FETCH_DEVICES_REQUEST,
  payload: { page, limit },
});

export const fetchDevicesSuccess = (devices) => ({
  type: FETCH_DEVICES_SUCCESS,
  payload: devices,
});

export const fetchDevicesFailure = (error) => ({
  type: FETCH_DEVICES_FAILURE,
  payload: error,
});

export const updateDeviceRequest = (device) => ({
  type: UPDATE_DEVICE_REQUEST,
  payload: device,
});

export const updateDeviceSuccess = (device) => ({
  type: UPDATE_DEVICE_SUCCESS,
  payload: device,
});

export const updateDeviceFailure = (error) => ({
  type: UPDATE_DEVICE_FAILURE,
  payload: error,
});

export const updatePaymentRequest = (payment) => ({
  type: UPDATE_PAYMENT_REQUEST,
  payload: payment,
});

export const updatePaymentSuccess = (payment) => ({
  type: UPDATE_PAYMENT_SUCCESS,
  payload: payment,
});

export const updatePaymentFailure = (error) => ({
  type: UPDATE_PAYMENT_FAILURE,
  payload: error,
});

export const searchDevicesRequest = (searchTerm) => ({
  type: SEARCH_DEVICES_REQUEST,
  payload: { searchTerm },
});

export const searchDevicesSuccess = (devices) => ({
  type: SEARCH_DEVICES_SUCCESS,
  payload: devices,
});

export const searchDevicesFailure = (error) => ({
  type: SEARCH_DEVICES_FAILURE,
  payload: error,
});

export const searchPaymentsRequest = (searchTerm) => ({
  type: SEARCH_PAYMENTS_REQUEST,
  payload: { searchTerm },
});

export const searchPaymentsSuccess = (devices) => ({
  type: SEARCH_PAYMENTS_SUCCESS,
  payload: devices,
});

export const searchPaymentsFailure = (error) => ({
  type: SEARCH_PAYMENTS_FAILURE,
  payload: error
})